import * as React from 'react';
import { ESubtitleOffset, SubtitleLayout } from '../SubtitleLayout';
import * as styles from './PhoneCallConfirmationInfo.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PhoneCallConfirmationInfo = function PhoneCallConfirmationInfo(_ref) {
  var phone = _ref.phone;
  return /*#__PURE__*/_jsx(SubtitleLayout, {
    offset: ESubtitleOffset.XL,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles['inner'],
      children: ["\u0417\u0432\u043E\u043D\u0438\u043C \u043D\u0430 ", /*#__PURE__*/_jsx("strong", {
        children: phone
      })]
    })
  });
};
PhoneCallConfirmationInfo.displayName = 'PhoneCallConfirmationInfo';